export default "__VITE_ASSET__CS4IrPPs__"